import { CombinedDocumentsMap, ReferenceCitationsMap } from 'models';
import { isReferenceCitation } from './entityType';
import { filterCombinedDocuments } from './filterCombinedDocuments';

export const filterReferenceCitations = (documents: CombinedDocumentsMap): ReferenceCitationsMap => {
  return filterCombinedDocuments(documents, isReferenceCitation) as ReferenceCitationsMap;
};
